module.exports = __webpack_public_path__ + "static/media/watch-calculator.9ed4494c.svg";